import { metersBetweenLatLon } from "./geo_math"
import { CLIENT_CONTRACT } from "./client_contract"

const MOBILE_FILTER_POLICY = CLIENT_CONTRACT.mobile.filterPolicy

export const METERS_PER_MILE = 1609.344
export const METERS_TO_MILES = 1 / METERS_PER_MILE
export const METERS_TO_FEET = 3.280839895
export const METERS_PER_SECOND_TO_MILES_PER_HOUR = 2.23694

export const WEB_LOCATION_POLICY = Object.freeze({
  browserLocateOptions: Object.freeze({
    enableHighAccuracy: false,
    timeout: 8000,
    maximumAge: 300000
  }),
  browserWatchOptions: Object.freeze({
    enableHighAccuracy: false,
    timeout: 10000,
    maximumAge: 10000
  }),
  trackerPoint: Object.freeze({
    maxAccuracyM: MOBILE_FILTER_POLICY.defaultMaxAccuracyM,
    maxSpeedMps: MOBILE_FILTER_POLICY.teleportMaxMps,
    jitterMinM: MOBILE_FILTER_POLICY.jitterMinM,
    slowSpeedMps: MOBILE_FILTER_POLICY.slowMaxMps,
    accuracyBubbleRatio: CLIENT_CONTRACT.web.location.trackerAccuracyBubbleRatio
  }),
  elevationRefreshMs: 5000,
  metersToMiles: METERS_TO_MILES,
  metersToFeet: METERS_TO_FEET,
  metersPerSecondToMilesPerHour: METERS_PER_SECOND_TO_MILES_PER_HOUR
})

export function browserLocationLocateOptions() {
  return { ...WEB_LOCATION_POLICY.browserLocateOptions }
}

export function browserLocationWatchOptions() {
  return { ...WEB_LOCATION_POLICY.browserWatchOptions }
}

export function metersToMiles(meters) {
  return Number(meters || 0) * WEB_LOCATION_POLICY.metersToMiles
}

export function metersToFeet(meters) {
  return Number(meters || 0) * WEB_LOCATION_POLICY.metersToFeet
}

export function speedMphLabel(speedMps) {
  const speed = sanitizeSpeedMps(speedMps)
  if (speed == null) return "–"
  return String(Math.round(speed * WEB_LOCATION_POLICY.metersPerSecondToMilesPerHour))
}

export function sanitizeSpeedMps(speedMps, maxMps = WEB_LOCATION_POLICY.trackerPoint.maxSpeedMps) {
  if (speedMps == null || (typeof speedMps === "string" && speedMps.trim() === "")) return null
  const speed = Number(speedMps)
  const maximum = Number(maxMps)
  if (!Number.isFinite(speed) || !Number.isFinite(maximum) || maximum < 0) return null
  return speed >= 0 && speed <= maximum ? speed : null
}

export function shouldRefreshElevation(lastRefreshAt, now, refreshMs = WEB_LOCATION_POLICY.elevationRefreshMs) {
  return !lastRefreshAt || now - lastRefreshAt >= refreshMs
}

export function webTrackerPointAction(fix, lastFix, policy = WEB_LOCATION_POLICY.trackerPoint) {
  if (!Number.isFinite(Number(fix?.lat)) || !Number.isFinite(Number(fix?.lon))) {
    return { kind: "drop", reason: "no_coords" }
  }
  if (fix.accuracy != null && Number(fix.accuracy) > policy.maxAccuracyM) {
    return { kind: "drop", reason: "poor_accuracy" }
  }
  if (!lastFix) return { kind: "accept" }

  const distanceM = metersBetweenLatLon([lastFix.lat, lastFix.lon], [fix.lat, fix.lon])
  const speed = sanitizeSpeedMps(fix.speed, policy.maxSpeedMps)
  const slowOrUnknown = speed == null || speed < policy.slowSpeedMps
  if (slowOrUnknown && distanceM < policy.jitterMinM) return { kind: "stationary", reason: "stationary_drift" }
  if (slowOrUnknown && fix.accuracy != null && distanceM < Number(fix.accuracy) * policy.accuracyBubbleRatio) {
    return { kind: "stationary", reason: "accuracy_bubble" }
  }

  return { kind: "accept" }
}
